import React from "react";
import { Link } from "react-router-dom";

const STATS = [
  { value: "30+", label: "Years of\nEnterprise Expertise" },
  { value: "200+", label: "Global\nClients" },
  { value: "70+", label: "Countries\nWorldwide" },
  { value: "ISO 9001", label: "Quality\nCertified" },
];

const LOGOS = [
  { name: "IATA" },
  { name: "Tata AIG Insurance" },
  { name: "Apollo Tyres" },
  { name: "Max Healthcare" },
  { name: "Yes Bank" },
  { name: "Thomas Cook" },
  { name: "SBI General Insurance" },
  { name: "Edelweiss" },
];

const NewCustomerProof = () => (
  <section className="proof-v2" aria-labelledby="proof-heading" id="customers">
    <div className="container">
      <div className="row align-items-center">
        {/* Stats */}
        <div className="col-lg-5 mb-4 mb-lg-0">
          <div className="row">
            {STATS.map(({ value, label }) => (
              <div key={label} className="col-6 mb-4 text-center">
                <div className="proof-v2-stat-val">{value}</div>
                <div className="proof-v2-stat-lbl" style={{ whiteSpace: "pre-line" }}>{label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA copy */}
        <div className="col-lg-7">
          <h2 id="proof-heading" style={{ fontSize: "clamp(1.4rem,2.5vw,2rem)", fontWeight: 800, color: "#fff", marginBottom: "12px" }}>
            Let's build what's next. Together.
          </h2>
          <p style={{ fontSize: "14px", color: "rgba(255,255,255,.65)", marginBottom: "20px", lineHeight: 1.65 }}>
            Managed services to keep your systems running · AI to make them smarter · FDE engineers on-site for the complex work.
          </p>

          <div className="proof-v2-contact-row">
            <a href="tel:+16094039000" className="proof-v2-contact-item">
              <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              +1 (609) 403-9000
            </a>
            <a href="mailto:inquiry@avanicimcon.com" className="proof-v2-contact-item">
              <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              inquiry@avanicimcon.com
            </a>
            <span className="proof-v2-contact-item">
              <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Princeton, New Jersey, USA
            </span>
          </div>

          <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
            <Link to="/contact-us" className="proof-v2-cta-btn-primary">
              Talk to Us
            </Link>
            <Link to="/services/legacy-modernization" className="proof-v2-cta-btn-outline">
              Discuss Your Modernization Roadmap
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>

    {/* Client logos */}
    <div className="proof-v2-logos">
      <div className="container">
        <p style={{ textAlign: "center", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: ".12em", color: "rgba(255,255,255,.4)", marginBottom: "24px" }}>
          Trusted by 200+ Global Clients
        </p>
        <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ gap: "16px" }}>
          {LOGOS.map(({ name }) => (
            <div key={name} className="proof-v2-logo-badge">
              {name}
            </div>
          ))}
        </div>
        <p style={{ textAlign: "center", marginTop: "24px", fontSize: "12px", color: "rgba(255,255,255,.4)" }}>
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ marginRight: "6px", verticalAlign: "middle" }} aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Clients in 70 countries across North America, South America, Europe, Middle East, Africa &amp; Asia Pacific.{" "}
          <Link to="/international-acceptance" style={{ color: "#f37417" }}>
            View international projects →
          </Link>
          {" · "}
          <Link to="/domestic-projects" style={{ color: "#f37417" }}>
            Domestic projects →
          </Link>
        </p>
      </div>
    </div>
  </section>
);

export default NewCustomerProof;
